import { TResponse, TTotal } from "@/module/common"
import { TCollectDataType } from "@/module/collect"
import { getAddCollect, getRemoveCollect, getCollectList } from "@/api/collect"
import { ElMessage } from 'element-plus'

// 添加收藏 Type 1录播 2直播
export async function GetAddCollect(tool: any, Id: number, Type: number) {
    let res: TResponse<boolean> = await getAddCollect({ ObjId: Id, ObjType: Type })
    let { Code, Data } = res
    if (Code === 200 && Data) {
        if (tool){ tool.numTotal++ }
    }else{
        ElMessage('收藏失败，请重试')
    }

}
// 取消收藏
export async function GetRemoveCollect(tool:any,Id: number, Type:number) {
    let res: TResponse<boolean> = await getRemoveCollect({ ObjId: Id, ObjType: Type })
    let { Code, Data } = res
    if (Code === 200 && Data) {
        if (tool) { tool.numTotal-- }
    }else{
        ElMessage('收藏失败，请重试')
    }
}

// 收藏列表
export async function GetCollectList(data: any) {
    let res: TResponse<TTotal<TCollectDataType>> = await getCollectList({ PageIndex: data.PageIndex, PageSize: data.PageSize })
    let { Code, Data } = res
    if (Code === 200) {
        data.list = Data.Data
        data.total = Data.Total
    }
}